import { LevelHistory } from './panelElements';

/** One 200-gesture stack per room for the lifetime of the signed-in browser session. */
const histories = new Map<string, LevelHistory>();

export function panelHistoryFor(roomIdentity: string): LevelHistory {
  const key = roomIdentity || 'unselected';
  let history = histories.get(key);
  if (!history) {
    history = new LevelHistory(200);
    histories.set(key, history);
  }
  return history;
}

export function clearPanelHistory(roomIdentity: string): void {
  const key = roomIdentity || 'unselected';
  histories.get(key)?.clear();
  histories.delete(key);
}

export function clearPanelHistories(): void {
  for (const history of histories.values()) history.clear();
  histories.clear();
}
